var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.023 2.013a.858.858 0 00-.99.702.861.861 0 00.697.998 4.26 4.26 0 012.775 1.765c1.361 1.944.897 4.64-1.035 6.011a4.277 4.277 0 01-5.976-1.041 4.338 4.338 0 01.331-5.377l.023.487a.858.858 0 001.35.666.865.865 0 00.363-.746L6.47 3.472a1.284 1.284 0 00-.418-.896 1.27 1.27 0 00-.925-.338l-1.995.093a.861.861 0 00-.818.902.86.86 0 00.897.822l.23-.011c-1.74 2.048-1.96 5.098-.348 7.398 1.907 2.722 5.66 3.376 8.365 1.458 2.707-1.919 3.356-5.694 1.45-8.416a5.96 5.96 0 00-3.884-2.471z"
  })));
}
export default SvgMedium;